import { render, staticRenderFns } from "./Ysts.vue?vue&type=template&id=a6cc08d6&"
import script from "./Ysts.vue?vue&type=script&lang=js&"
export * from "./Ysts.vue?vue&type=script&lang=js&"
import style0 from "./Ysts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports